var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Collectible = function() {
    EHDI.aka.Container2d.call(this);
};

EHDI.game.Collectible.prototype = Object.create(EHDI.aka.Container2d.prototype);

EHDI.game.Collectible.prototype.init = function () {
  this._collectibleX = 0;

  this._sprite;
  this._shadow;
  this._text;
  this._animateUp = false;
  this._animation;
  this._textContainer;
  this._animationName;
  this._collected = false;
  this._collectibleCount;
  this._time;
  this._timerDelay = 3000;
  this._blinkOut = false;
  this._alphaOut = true;

  if (this._shadow == null) {
    this._shadow = new EHDI.aka.Sprite2d(EHDI.Assets.images["shadow3"]);
    this._shadow.anchor.set(0.5,0.5);

    this._shadow.proj.affine = PIXI.projection.AFFINE.AXIS_Y;

    this.addChild(this._shadow);
  }

  if (this._sprite == null) {
    this._sprite = new EHDI.aka.Sprite2d(EHDI.Assets.images["pickup1"]);
    this._sprite.anchor.set(0.5,0.5);
    this._sprite.y = -120;

    this._sprite.proj.affine = PIXI.projection.AFFINE.AXIS_Y;

    this.addChild(this._sprite);
  }

  if (this._textContainer == null) {
    this._textContainer = new EHDI.aka.Container();

    this.addChild(this._textContainer);
  }

  if (this._text1 == null) {
    this._text1 = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_COL_MULTIPLIER1"));

    this._text1.anchor.x = 0.5;
    this._text1.anchor.y = 0.5;

    this._text1.position.set(0,-16);
    this._textContainer.addChild(this._text1);
  }

  if (this._text2 == null) {
    this._text2 = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_COL_MULTIPLIER2"));

    this._text2.anchor.x = 0.5;
    this._text2.anchor.y = 0.5;

    this._text2.position.set(0,16);
    this._textContainer.addChild(this._text2);
  }

  if (this._animation == null) {
    this._animation = new EHDI.game.Effect();
    this._animation.init('burst_fx');

    // this._animation.getDisplay().x = -100;
    this._animation.getDisplay().visible = false;
    this.addChild(this._animation.getDisplay());
  }

  if (this._time == null) {
    this._time = new EHDI.util.Time();
  }

  this.proj.affine = PIXI.projection.AFFINE.AXIS_X;
  this.scale.x = 0.9;
  this.scale.y = 0.9;

  this.visible = false;
  this._active = false;
}

EHDI.game.Collectible.prototype.isActive = function () {
  return this._active;
}

EHDI.game.Collectible.prototype.isCollected = function () {
  return this._collected;
}

EHDI.game.Collectible.prototype.getCollectibleCount = function () {
  return this._collectibleCount;
}

EHDI.game.Collectible.prototype.spawn = function (xPos, collectibleCount) {
  this._collectibleCount = collectibleCount;
  this._blinkOut = false;
  this._alphaOut = true;
  this._time.reset();
  this.alpha = 1;

  if (collectibleCount == 0) {
    this._sprite.texture = EHDI.Assets.images["pickup1"];
    this._animationName = 'pickglow1';
    this._text1.text = EHDI.GAME.jsonManager.getLocale("STR_COL_MULTIPLIER1").TEXT;
    this._text2.text = EHDI.GAME.jsonManager.getLocale("STR_COL_MULTIPLIER2").TEXT;
  } else if (collectibleCount == 1) {
    this._sprite.texture = EHDI.Assets.images["pickup2"];
    this._animationName = 'pickglow2';
    this._text1.text = EHDI.GAME.jsonManager.getLocale("STR_COL_ADDITIONAL_DISC1").TEXT;
    this._text2.text = EHDI.GAME.jsonManager.getLocale("STR_COL_ADDITIONAL_DISC2").TEXT;
  } else if (collectibleCount == 2) {
    this._sprite.texture = EHDI.Assets.images["pickup3"];
    this._animationName = 'pickglow3';
    this._text1.text = EHDI.GAME.jsonManager.getLocale("STR_COL_BONUS1").TEXT;
    this._text2.text = EHDI.GAME.jsonManager.getLocale("STR_COL_BONUS2").TEXT;
  }

  this._active = true;
  this.visible = true;
  this._collected = false;
  this._animation.getDisplay().visible = false;
  this._textContainer.alpha = 1;

  this._sprite.visible = true;
  this._shadow.visible = true;

  this._shadow.x = xPos;
  this._sprite.x = xPos;
  this._collectibleX = xPos;

  this._textContainer.x = this._sprite.x;
  this._textContainer.y = this._sprite.y;

  this._shadow.scale.x = 0;
  this._shadow.scale.y = 0;
  this._sprite.scale.x = 0;
  this._sprite.scale.y = 0;
  this._textContainer.scale.x = 0;
  this._textContainer.scale.y = 0;

  TweenLite.to(this._shadow.scale, 0.2,{x:1, y:1});
  TweenLite.to(this._sprite.scale, 0.2,{x:1, y:1});
  TweenLite.to(this._textContainer.scale, 0.2,{x:1, y:1});
}

EHDI.game.Collectible.prototype.getCollectibleX = function () {
  return this._collectibleX;
}

EHDI.game.Collectible.prototype.explode = function () {
  this._active = false;
  this._collected = true;
  this._sprite.visible = false;
  this._shadow.visible = false;
  this.alpha = 1;

  this._animation.getDisplay().x = this._sprite.x;
  this._animation.getDisplay().y = this._sprite.y;

  this._animation.changeAnimation(false, this._animationName);
  this._animation.getDisplay().visible = true;

  this._tl1 = TweenLite.to(this._textContainer, 1.5,{y:this._textContainer.y - 150, alpha:0});
  // this._tl1 = TweenLite.to(this._text1.position, 0.5,{y:this._text1.position.y - 20});
  // this._tl2 = TweenLite.to(this._text2.position, 0.5,{y:this._text2.position.y - 20});
}

EHDI.game.Collectible.prototype.remove = function () {
  this._active = false;
  this._sprite.visible = false;
  this._shadow.visible = false;
}

EHDI.game.Collectible.prototype.update = function () {
  if (this._active) {
    if (this._animateUp) {
      this._sprite.y -= 0.2;

      if (this._sprite.y <= -130) {
        this._sprite.y = -130;
        this._animateUp = false;
      }
    } else {
      this._sprite.y += 0.2;

      if (this._sprite.y >= -110) {
        this._sprite.y = -110;
        this._animateUp = true;
      }
    }

    this._textContainer.y = this._sprite.y;
    this.manageDespawn();
  }
}

EHDI.game.Collectible.prototype.manageDespawn = function () {
  if (!this._blinkOut) {
    if (this._timerDelay <= this._time.getTime()) {
      this._blinkOut = true;
      this._time.reset();
    }
  } else {
    if (this._alphaOut) {
      this.alpha -= 0.02;

      if (this._timerDelay > this._time.getTime()) {
        if (this.alpha <= 0.5) {
          this.alpha = 0.5;
          this._alphaOut = false;
        }
      } else {
        if (this.alpha <= 0) {
          this.alpha = 0;
          this.remove();
        }
      }

    } else {
      this.alpha += 0.02;
      if (this.alpha >= 1) {
        this.alpha = 1;
        this._alphaOut = true;
      }
    }
  }
}
